import {
  Divider,
  Grid,
  Typography
} from '@mui/material'
import { ReactComponent as BibIcon } from '../../../../assets/bib-icon.svg'
import { ReactComponent as TagIcon } from '../../../../assets/tag-icon.svg'
import { useStyles } from './CheckinModal.styles'
import {
  athleteName,
  regTime
} from '../../utils/modalUtils'
import { createLogger } from '../../../../app/logger'
import {
  getSelectedEntrySelector
} from '../../checkinSlice'
import useAppSelector from '../../../../hooks/useAppSelector'
import { EntryPanelLineItem, EntryPanelLineItems } from './EntryPanelLineItems'
import { EntryPanelBibField } from './EntryPanelBibField'
import { EntryPanelTagField } from './EntryPanelTagField'
import useCheckinSettings from '../../hooks/useCheckinSettings'

// eslint-disable-next-line no-unused-vars
const logger = createLogger({
  prefix: 'EntryPanel'
})

// ==================================================================================================

export const EntryPanel = () => {
  const entry = useAppSelector(getSelectedEntrySelector)
  const { classes } = useStyles()
  const { standardOptions, customQuestions, thirdPartyQuestions, settings } = useCheckinSettings().checkinAllSettings

  return (
    <Grid container>

      <Grid container item xs={12} flexDirection={'row-reverse'} justifyContent={'flex-end'} marginTop={'10px'}>
        <Grid item xs={12} sm={4}>
          <Grid container item xs={12} alignItems={'flex-start'}>
            <Grid item xs={4} display={'flex'} alignItems={'center'} flexWrap={'nowrap'}>
              <BibIcon className={classes.fieldIcon} data-cy={'bib-field-icon'} />
              <Typography className={classes.label}>BIB</Typography>
              <Typography className={classes.label}>#</Typography>
            </Grid>
            <Grid item xs={8}>
              <EntryPanelBibField />
            </Grid>
          </Grid>

          {settings?.askForTag && (
            <Grid container item xs={12} alignItems={'flex-start'}>
              <Grid item xs={4} display={'flex'} alignItems={'center'} flexWrap={'nowrap'}>
                <TagIcon className={classes.fieldIcon} data-cy={'tag-field-icon'} />
                <Typography className={classes.label}>TAG</Typography>
                <Typography className={classes.label}>#</Typography>
              </Grid>
              <Grid item xs={8}>
                <EntryPanelTagField />
              </Grid>
            </Grid>
          )}
        </Grid>

        <Grid item sm={8} alignItems={'left'}>
          <EntryPanelLineItem key='Name' label='Name' value={athleteName(entry)} />
          <EntryPanelLineItem key='Registered' label='Registered' value={regTime(entry)} />
          <EntryPanelLineItem key='Race' label='Race' value={entry?.raceName} />
        </Grid>
      </Grid>
      <Grid container flexDirection={'column'}>
        <Divider/>
        <EntryPanelLineItems options={standardOptions}/>
        <Divider/>
        <EntryPanelLineItems options={customQuestions}/>
        <Divider/>
        <EntryPanelLineItems options={thirdPartyQuestions}/>
      </Grid>
    </Grid>
  )
}
